// See this piece of documentation to retrieve fields IDs:
// https://developer.zendesk.com/api-reference/ticketing/tickets/ticket_fields/#list-ticket-fields
export const WORKSPACE_ID_FIELD_ID = 5931238602385

// See this piece of documentation to retrieve forms IDs:
// https://developer.zendesk.com/api-reference/ticketing/tickets/ticket_forms/#list-ticket-forms
export const DEFAULT_FORM_ID = 4423096547601
